<template>
  <div>
    <!-- 运营分析 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tab">
      <span
        v-for="(v,i) in tabBtn"
        :key="v.id"
        @click="tabTitle(i)"
        :class="activeIndex==i?'activeTab':''"
      >{{v.name}}</span>
    </div>
    <!-- 商品分析 -->
    <div class="content" v-if="activeIndex==0">
      <div class="contentLeft">
        <div class="titleSear">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button>查询</el-button>
        </div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="排序" type="index"></el-table-column>
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <el-table-column prop="name" label="销售数量"></el-table-column>
          <el-table-column prop="name" label="销售额"></el-table-column>
          <el-table-column prop="name" label="销售额占比"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <div class="contentRight">
        <div id="shop" style="width: 600px; height: 400px"></div>
      </div>
    </div>
    <!-- 销售分析 -->
    <div v-if="activeIndex==1">
      <el-card style="margin:20px 0">
        <div class="titleOne">
          <div>
            <el-select v-model="value" clearable placeholder="类别">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button>查询</el-button>
          </div>
          <div>
            <el-button>销售额</el-button>
            <el-button>销售数量</el-button>
            <el-button>核销数量</el-button>
            <el-button>图片数量</el-button>
          </div>
        </div>
      </el-card>
      <el-card style="margin:20px 0">
        <div style="display:flex;justify-content: center;
    align-items: center;">
          <div id="xsAns" style="width: 1325px;height:300px;"></div>
        </div>
      </el-card>
      <el-card class="xsfxTable">
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="排序" type="index"></el-table-column>
          <el-table-column prop="name" label="日期"></el-table-column>
          <el-table-column prop="name" label="销售额"></el-table-column>
          <el-table-column prop="name" label="销售数量"></el-table-column>
          <el-table-column prop="name" label="核销数量"></el-table-column>
          <el-table-column prop="name" label="退票数量"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 分销分析 -->
    <div class="content" v-if="activeIndex==2">
      <div class="contentLeft">
        <div class="titleSear">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button>查询</el-button>
        </div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column label="排序" type="index"></el-table-column>
          <el-table-column prop="name" label="商品名称"></el-table-column>
          <el-table-column prop="name" label="销售数量"></el-table-column>
          <el-table-column prop="name" label="销售额"></el-table-column>
          <el-table-column prop="name" label="销售额占比"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <div class="contentRight">
        <div id="fxAns" style="width: 600px; height: 400px"></div>
      </div>
    </div>
    <!-- 用户分析 -->
    <div v-if="activeIndex==3">
      <el-card style="margin:20px 0">
        <div class="titleOne">
          <div>
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <el-button>查询</el-button>
          </div>
        </div>
      </el-card>
      <el-card>
        <div class="managingPatientSize">
          <el-row>
            <el-col :span="6">1</el-col>
            <el-col :span="12">
              <div id="china-map"></div>
            </el-col>
            <el-col :span="6">1</el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "@/assets/china.js";
// 引入 ECharts 主模块
// var echarts = require("echarts/lib/echarts");
// 引入柱状图
// require("echarts/lib/chart/bar");
// require("echarts/lib/chart/line");
// // 引入提示框和标题组件
// require("echarts/lib/component/tooltip");
// require("echarts/lib/component/title");
// require("echarts/lib/chart/pie");
// require("echarts/lib/component/markLine");
// require("echarts/lib/component/geo");
// require("echarts/lib/chart/scatter");
// require("echarts/lib/chart/map");
export default {
  data() {
    return {
      tabBtn: [
        {
          id: 1,
          name: "商品分析"
        },
        {
          id: 2,
          name: "销售分析"
        },
        {
          id: 3,
          name: "分销分析"
        },
        {
          id: 4,
          name: "用户分析"
        }
      ],
      activeIndex: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "57674"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "2464634"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "43434"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "1345"
        }
      ],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  mounted() {
    this.shopChart();
    this.drawCharts();
  },
  methods: {
    // 用户分析
    drawCharts() {
      // 基于准备好的dom，初始化echarts实例
      var chinaMap = echarts.init(document.getElementById("china-map"));
      window.onresize = chinaMap.resize; // 窗口或框架被调整大小时执行chinaMap.resize
      chinaMap.setOption({
        // 进行相关配置
        tooltip: {}, // 鼠标移到图里面的浮动提示框
        dataRange: {
          show: false,
          min: 0,
          max: 1000,
          text: ["High", "Low"],
          realtime: true,
          calculable: true,
          color: ["orangered", "#FF9B52", "#FFD068"]
        },
        geo: {
          // 这个是重点配置区
          map: "china", // 表示中国地图
          roam: true,
          label: {
            normal: {
              show: true, // 是否显示对应地名
              textStyle: {
                color: "#fff"
              }
            }
          },
          itemStyle: {
            normal: {
              borderColor: "#293171",
              borderWidth: "2",
              areaColor: "#0A0F33"
            },
            emphasis: {
              areaColor: null,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        },
        series: [
          {
            type: "scatter",
            coordinateSystem: "geo" // 对应上方配置
          },
          {
            name: "启动次数", // 浮动框的标题
            type: "map",
            geoIndex: 0,
            data: [
              {
                name: "北京",
                value: 599
              },
              {
                name: "上海",
                value: 142
              },
              {
                name: "黑龙江",
                value: 44
              },
              {
                name: "深圳",
                value: 92
              },
              {
                name: "湖北",
                value: 810
              },
              {
                name: "四川",
                value: 453
              }
            ]
          }
        ]
      });
    },
    // 商品分析图表
    shopChart() {
      var chartDom = document.getElementById("shop");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        legend: {
          top: "bottom",
          icon: "rect"
        },
        series: [
          {
            name: "Nightingale Chart",
            type: "pie",
            radius: [50, 250],
            center: ["50%", "50%"],
            roseType: "area",
            itemStyle: {
              borderRadius: 8
            },
            data: [
              { value: 40, name: "rose 1" },
              { value: 38, name: "rose 2" },
              { value: 32, name: "rose 3" },
              { value: 30, name: "rose 4" },
              { value: 28, name: "rose 5" },
              { value: 26, name: "rose 6" },
              { value: 22, name: "rose 7" },
              { value: 18, name: "rose 8" }
            ]
          }
        ]
      };

      option && myChart.setOption(option);
    },
    // 销售分析图表
    xsAnalysisChart() {
      var chartDom = document.getElementById("xsAns");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "销售分析 "
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["销售金额", "销售数量", "核销数量", "退票数量"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "销售金额",
            type: "line",
            stack: "Total",
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: "销售数量",
            type: "line",
            stack: "Total",
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: "核销数量",
            type: "line",
            stack: "Total",
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: "退票数量",
            type: "line",
            stack: "Total",
            data: [320, 332, 301, 334, 390, 330, 320]
          }
        ]
      };

      option && myChart.setOption(option);
    },
    // 销售分析图表
    fxAnalysisChart() {
      var chartDom = document.getElementById("fxAns");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        tooltip: {
          trigger: "item"
        },
        legend: {
          top: "5%",
          left: "center"
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 1048, name: "Search Engine" },
              { value: 735, name: "Direct" },
              { value: 580, name: "Email" },
              { value: 484, name: "Union Ads" },
              { value: 300, name: "Video Ads" }
            ]
          }
        ]
      };

      myChart.setOption(option);
    },
    tabTitle(index) {
      // console.log(index);
      this.activeIndex = index;
      console.log(this.activeIndex);
      if (index == 0) {
        this.$nextTick(() => {
          this.shopChart();
        });
      }
      if (index == 1) {
        this.$nextTick(() => {
          this.xsAnalysisChart();
        });
      }
      if (index == 2) {
        this.$nextTick(() => {
          this.fxAnalysisChart();
        });
      }
      if (index == 3) {
        this.$nextTick(() => {
          this.drawCharts();
        });
      }
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.managingPatientSize {
  height: 100%;
  color: #fff;
  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      position: relative;
      #china-map {
        height: 100%;
      }
    }
  }
}
.xsfxTable {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 20px auto 0px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}
.titleOne {
  display: flex;
  justify-content: space-between;
  > div:nth-child(1) {
    width: 50%;
    .el-select {
      width: 260px;
    }
    .el-button {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
      margin-left: 20px;
    }
  }
  > div:nth-child(2) {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    .el-button {
      width: 110px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #246deb;
      margin-right: 10px;
    }
  }
}
.titleSear {
  margin-bottom: 20px;
  .el-input {
    width: 300px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-left: 20px;
  }
}
.content {
  width: 100%;
  height: 79vh;
  display: flex;
  justify-content: space-between;
  .contentLeft {
    width: 49.3%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px;
  }
  .contentRight {
    width: 49.3%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>